import type { JSX } from 'react';

import { HeadTitle } from '@/client/components/head-title';
import { NovaChatFeature } from '@/client/features/nova-chat';

export default function ChatPage(): JSX.Element {
  return (
    <>
      <HeadTitle title="Nova - Chat" />
      <NovaChatFeature />
    </>
  );
}
